// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verfy-wrap {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  background: url('mesh-gradient.d2e368c6b9d92bb7.png') center center;
  background-size: cover;
  flex-direction: column;
}
.verfy-wrap .verfy-screen-logo {
  margin-top: 60px;
}
.verfy-wrap .verfy-box {
  background: #ffffff;
  border-radius: 20px;
  padding: 40px 94px;
  text-align: center;
  width: 794px;
  margin-top: 60px;
  max-width: 90%;
}
.verfy-wrap .verfy-box h2 {
  font-weight: 600;
  font-size: 32px;
  line-height: 30px;
  color: #000;
  margin-bottom: 16px;
}
.verfy-wrap .verfy-box p {
  font-weight: 400;
  font-size: 24px;
  line-height: 30px;
  text-align: center;
  color: #000000;
}
.verfy-wrap .verfy-box .password-wrapper {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 40px;
  padding: 0 20px;
  height: 54px;
  position: relative;
  width: 100%;
}
@media (max-width: 768px) {
  .verfy-wrap .verfy-box {
    padding: 40px 20px;
  }
  .verfy-wrap .verfy-box p {
    font-size: 16px;
    padding: 0 25px;
  }
}

.verify-agency-logo {
  max-width: 450px;
}

.powered-wrapper {
  margin-top: 60px;
  display: flex;
  gap: 4px;
  flex-direction: column;
}
.powered-wrapper span {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: -0.25px;
  color: #1f2937;
}
.powered-wrapper .image-wrapper {
  width: 168px;
}
.powered-wrapper .image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

::-webkit-inner-spin-button {
  display: none;
}

.table-search-wrapper {
  width: 452px;
  height: 46px;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  margin-right: 24px;
  overflow: hidden;
}
.table-search-wrapper .table-search-field {
  border: none;
  padding: 0;
  flex: 1 1 auto;
}
.table-search-wrapper .p-inputgroup-addon {
  background: #fff;
  border: none;
  cursor: pointer;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
